<template>
  <div class="flex w-full md:w-2/3 sm:w-10/12">
    <input
      type="text"
      @keyup.enter="$emit('search')"
      :value.sync="value"
      @input="$emit('input', $event.target.value)"
      class="form-control border-r-0 h-10 flex-grow px-5 rounded-r-none text-sm"
    >
    <button class="w-32 bg-purple-500 text-white h-10 px-5 border border-purple-400 light:border-purple-600 rounded-r focus:outline-none hover:bg-purple-800 hover:border-purple-700" @click="$emit('search', value)">Search</button>
  </div>
</template>

<script>
export default {
  name: 'list-search',
  props: {
    value: {},
  }
}
</script>
